import { NgModule } from '@angular/core';
//import { CommonModule } from '@angular/common';
import { CanalInternoComponent } from './canal-interno/canal-interno.component';
import { RouterModule } from '@angular/router';
// import { CommonComponentsModule } from '../common/common-components.module';
// import { SharedComponentsModule } from '../core/shared/components/shared-components.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../app-translate-loader';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from '../core/shared/shared.module';

@NgModule({
  declarations: [CanalInternoComponent],
  imports: [
    //CommonModule,
    //CommonComponentsModule,
    //SharedComponentsModule,
    SharedModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RouterModule.forChild([{ path: '', component: CanalInternoComponent }])
  ]
})
export class CanalInternoModule { }
